import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [resetToken, setResetToken] = useState(null);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const sendPasswordResetEmail = async () => {
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) {
        setError(error.message);
      } else {
        setSuccessMessage('Password reset email sent. Check your inbox.');
      }
    } catch (err) {
      setError('Unexpected error occurred. Please try again.');
    }
  };

  const updatePassword = async () => {
    try {
      const { error } = await supabase.auth.updateUser({ password: newPassword });
      if (error) {
        setError(error.message);
      } else {
        setSuccessMessage('Password updated successfully. You can now log in.');
        setNewPassword('');
        setResetToken(null);
      }
    } catch (err) {
      setError('Unexpected error occurred. Please try again.');
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromQuery = queryParams.get('token');
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const tokenFromHash = hashParams.get('access_token');
    if (tokenFromQuery) setResetToken(tokenFromQuery);
    else if (tokenFromHash) setResetToken(tokenFromHash);
  }, [location.search]);

  const inputClass = "w-full px-4 py-3 text-base border border-lattice-card-border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-lattice-green focus:border-transparent transition-shadow";

  return (
    <div className="max-w-md mx-auto mt-16 px-4">
      <div className="bg-white border border-lattice-card-border rounded-xl shadow-sm p-8">
        {!resetToken ? (
          <>
            <h1 className="text-2xl font-bold text-lattice-dark text-center mb-8">Forgot your password</h1>

            {error && (
              <div className="mb-4 px-4 py-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-700 text-sm">{error}</p>
              </div>
            )}
            {successMessage && (
              <div className="mb-4 px-4 py-3 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-green-700 text-sm">{successMessage}</p>
              </div>
            )}

            <div className="mb-5">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={inputClass}
              />
            </div>

            <button
              onClick={sendPasswordResetEmail}
              className="w-full py-3 bg-lattice-green hover:bg-lattice-green-hover text-lattice-btn-text rounded-lg font-semibold text-base transition-colors"
            >
              Send reset email
            </button>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-lattice-dark text-center mb-8">Reset your password</h1>

            {error && (
              <div className="mb-4 px-4 py-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-700 text-sm">{error}</p>
              </div>
            )}
            {successMessage && (
              <div className="mb-4 px-4 py-3 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-green-700 text-sm">{successMessage}</p>
              </div>
            )}

            <div className="mb-5">
              <input
                type="password"
                placeholder="Enter your new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className={inputClass}
              />
            </div>

            <button
              onClick={updatePassword}
              className="w-full py-3 bg-lattice-green hover:bg-lattice-green-hover text-lattice-btn-text rounded-lg font-semibold text-base transition-colors mb-3"
            >
              Update password
            </button>

            {successMessage && (
              <button
                onClick={() => navigate('/')}
                className="w-full py-2.5 text-lattice-muted hover:text-lattice-dark text-sm transition-colors"
              >
                Go to login
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
